import React from 'react';
import { toast } from 'react-toastify';
import { Bookmark, BookmarkCheck } from 'lucide-react';

const BookmarkButton = ({ isSaved, onToggle }) => {
  const handleBookmark = () => {
    try {
      onToggle();
      toast.success(
        isSaved,
        {
          style: {
            backgroundColor: '#d4edda',
            color: '#155724',
          },
          progress: undefined,
        }
      );
    } catch (error) {
      toast.error('Something went wrong. Please try again.', {
        style: {
          backgroundColor: '#f8d7da',
          color: '#721c24',
        },
        progress: undefined,
      });
    }
  };

  return (
    <button
      onClick={handleBookmark}
      className={`p-2 rounded-full transition-colors duration-200 ${
        isSaved ? 'bg-green-500 hover:bg-green-600' : 'bg-gray-200 hover:bg-gray-300'
      }`}
      aria-label={isSaved ? 'Remove from saved' : 'Save exercise'}
    >
      {isSaved ? (
        <BookmarkCheck className="text-white" />
      ) : (
        <Bookmark className="text-gray-700" />
      )}
    </button>
  );
};

export default BookmarkButton;
